import React, { useEffect, useState } from "react";
import "./TitlePage.scss";
import Header from "./components/Header/Header";
import Title from "./components/Title/Title";
import Aos from "aos";
import "aos/dist/aos.css";
import AnchorLink from "react-anchor-link-smooth-scroll";

export default function TitlePage() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div className="title-page">
      <div>
        <div className="blur"></div>
        <div data-aos="zoom-in" className="title-page__background"></div>
      </div>

      <div className="title-page__content">
        <Header />
        <Title />
        
      </div>
    </div>
  );
}
